// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NWaL","left":"styles_left__2V_ZA","desktopActions":"styles_desktopActions__37hqU","title":"styles_title__1mnzQ"};